import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import UrlForm from "@/components/UrlForm";
import { Compass, ArrowLeft, Search } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col page-enter">
      <Seo
        title="Page introuvable"
        description="La page que vous cherchez n'existe pas ou a été déplacée. Retournez à l'accueil pour vérifier la fiabilité d'un site."
        path="/404"
        noindex
      />
      <Header />
      <main className="flex-1 bg-[#F8FAFC] flex items-center py-16">
        <div className="container-app max-w-2xl text-center">
          <div
            className="inline-flex w-20 h-20 rounded-2xl bg-[#EEF4F8] border border-[#CBD5E1] items-center justify-center mb-8"
            data-testid="not-found-icon"
          >
            <Compass className="w-10 h-10 text-[#163A5F]" />
          </div>

          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#163A5F] mb-3">
            Erreur 404
          </p>
          <h1 className="text-4xl sm:text-5xl font-extrabold font-heading text-[#111827] tracking-tight mb-4">
            Page introuvable
          </h1>
          <p className="text-[#4B5563] text-base leading-relaxed mb-10 max-w-md mx-auto">
            La page que vous cherchez n'existe pas, a été déplacée, ou n'a peut-être jamais existé.
            Pas de panique : vous pouvez vérifier un site juste ici.
          </p>

          <div className="card-base p-6 mb-8">
            <p className="text-sm font-semibold text-[#111827] mb-4 flex items-center justify-center gap-2">
              <Search className="w-4 h-4 text-[#163A5F]" />
              Vérifier un site
            </p>
            <UrlForm />
          </div>

          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#163A5F] text-sm font-semibold hover:underline"
            data-testid="not-found-home-link"
          >
            <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
